import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CompetitionHelperService } from '@app/support/helpers/competition-helper.service';
import { Competition } from '@app/support/models/competition.model';
import { DeleteCompetitionAction, UpdateCompetitionAction } from '@app/support/states/competition/competition.actions';
import { Store } from '@ngxs/store';
import { DayDiffPipe } from '@shared/pipes/day-diff.pipe';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { DealerCompetitionActionType } from '@app/support/modules/competition/enums/dealer-competition-action-type.enum';

@Component({
  selector: 'app-dealer-competition-dialog',
  templateUrl: './dealer-competition-dialog.component.html',
  styleUrls: ['./dealer-competition-dialog.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, IceButtonComponent, MatDialogClose, DayDiffPipe],
})
export class DealerCompetitionDialogComponent {
  private store = inject(Store);
  dialogRef = inject<MatDialogRef<DealerCompetitionDialogComponent>>(MatDialogRef);
  data = inject<{
    dealerCompetitionAction: DealerCompetitionActionType;
    dealerCompetition: Competition;
  }>(MAT_DIALOG_DATA);

  DealerCompetitionActionType = DealerCompetitionActionType;
  currentDate = new Date().toString();

  get confirmButtonText() {
    switch (this.data.dealerCompetitionAction) {
      case DealerCompetitionActionType.Delete:
        return 'Slett konkurranse';
      case DealerCompetitionActionType.DeleteDraft:
        return 'Slett utkast';
      case DealerCompetitionActionType.End:
        return 'Avslutt konkurranse';
      default:
        return 'Ok';
    }
  }

  onConfirmCompetitionAction() {
    switch (this.data.dealerCompetitionAction) {
      case DealerCompetitionActionType.Delete:
        this.store.dispatch(new DeleteCompetitionAction(this.data.dealerCompetition.id));
        break;
      case DealerCompetitionActionType.End:
        const competitionToUpdate = CompetitionHelperService.mapToUpdateCompetition(this.data.dealerCompetition);
        competitionToUpdate.endDate = new Date();
        this.store.dispatch(new UpdateCompetitionAction(competitionToUpdate));
        break;
    }
    this.dialogRef.close({ event: this.data.dealerCompetitionAction });
  }
}
